export default "__VITE_ASSET__Co2ND0Ts__"